import SvgIcon from "@mui/material/SvgIcon";
import { ReactComponent as MegaIcon } from "./Mega.svg";

export default function MediaFire(props: any) {
  return (
    <SvgIcon component={ MegaIcon } {...props} />
  );
}
